import { ConcreteEncodable } from "./ConcreteEncodable";

import { CustomValueImplEncoder } from "../../encoder/CustomValueImplEncoder";

import * as CubiqTS from "../../index";
import { CustomValue } from "../CustomValue";

export class CustomValueImpl extends ConcreteEncodable implements CustomValue {
  public static enType: string = "com.bcdfx.model.event.lifecycle.CustomValueImpl";

  /*FID=1*/
  public fieldId: string;
  /*FID=2*/
  public value: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CustomValueImplEncoder.Instance;
    this.setEncodableType(CustomValueImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CustomValueImpl[" +
      "fieldId=" +
      this.fieldId +
      "value=" +
      this.value +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
